import {
  ILSHeaderPlaceholder,
  ILSParagraphPlaceholder,
} from "@components/ILSPlaceholder";
import { Media } from "@components/Media";
import { ShowMoreContent } from "@components/ShowMoreContent";
import LiteratureCover from "@modules/Literature/LiteratureCover";
import _get from "lodash/get";
import PropTypes from "prop-types";
import React, { Component } from "react";
import Overridable from "react-overridable";
import { Grid } from "semantic-ui-react";
import SpecialCollectionPanelMobile from "./SpecialCollectionPanelMobile";
import { SpecialCollectionTitle } from "@modules/SpecialCollections/SpecialCollectionTitle";
import SpecialCollectionAuthors from "@modules/SpecialCollections/SpecialCollectionAuthors";
import { SpecialCollectionAccess } from "@modules/SpecialCollections/SpecialCollectionAccess";

class SpecialCollectionPanel extends Component {
  render() {
    const { specialCollectionDetails: specialCollection, isLoading } =
      this.props;

    return (
      <>
        <Overridable
          id="SpecialCollectionPanel.layout"
          specialCollectionDetails={specialCollection}
          isLoading={isLoading}
        >
          <>
            <Media greaterThanOrEqual="tablet">
              <div
                className="literature-panel"
                data-test={
                  specialCollection.metadata
                    ? specialCollection.metadata.pid
                    : 0
                }
              >
                <Grid columns={3}>
                  <Grid.Row>
                    <Grid.Column>
                      <LiteratureCover
                        url={_get(
                          specialCollection,
                          "metadata.cover_metadata.urls.large"
                        )}
                        isLoading={isLoading}
                      />
                    </Grid.Column>
                    <Grid.Column>
                      <Overridable
                        id="SpecialCollectionPanel.SpecialCollectionTitle"
                        specialCollectionDetails={specialCollection}
                        isLoading={isLoading}
                      >
                        <ILSHeaderPlaceholder isLoading={isLoading}>
                          <SpecialCollectionTitle
                            metadata={specialCollection.metadata}
                          />
                        </ILSHeaderPlaceholder>
                      </Overridable>

                      <ILSParagraphPlaceholder
                        linesNumber={2}
                        isLoading={isLoading}
                      >
                        <SpecialCollectionAuthors
                          authors={specialCollection.metadata.authors}
                          prefix="by "
                          listItemAs="h4"
                        />
                        <Overridable
                          id="SpecialCollectionPanel.AfterAuthors"
                          metadata={specialCollection.metadata}
                        />
                        {specialCollection.metadata.academic_info && (
                          <div className="default-margin-bottom">
                            <b>
                              {_get(
                                specialCollection.metadata,
                                "academic_info.department",
                                ""
                              )}
                            </b>
                            {_get(
                              specialCollection.metadata,
                              "academic_info.program"
                            ) && (
                              <>
                                {" "}
                                |{" "}
                                <b>
                                  {
                                    specialCollection.metadata.academic_info
                                      .program
                                  }
                                </b>
                              </>
                            )}
                          </div>
                        )}
                      </ILSParagraphPlaceholder>
                      <ILSParagraphPlaceholder
                        linesNumber={15}
                        isLoading={isLoading}
                      >
                        <ShowMoreContent lines={15}>
                          {specialCollection.metadata.abstract}
                        </ShowMoreContent>
                      </ILSParagraphPlaceholder>
                    </Grid.Column>
                    <Grid.Column>
                      <SpecialCollectionAccess
                        metadata={specialCollection.metadata}
                        isLoading={isLoading}
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </div>
            </Media>
            <Media at="mobile">
              <SpecialCollectionPanelMobile
                isLoading={isLoading}
                specialCollectionDetails={specialCollection}
              />
            </Media>
          </>
        </Overridable>
        <Overridable id="SpecialCollectionPanel.Extras" />
      </>
    );
  }
}

SpecialCollectionPanel.propTypes = {
  specialCollectionDetails: PropTypes.object.isRequired,
  isLoading: PropTypes.bool,
};

SpecialCollectionPanel.defaultProps = {
  isLoading: false,
};

export default Overridable.component(
  "SpecialCollectionPanel",
  SpecialCollectionPanel
);
